/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBrandValorant = createSolidComponent("brand-valorant", "IconBrandValorant", [
  ["path", { d: "M14.5 14h4.5l2 -2v-6z" }],
  ["path", { d: "M9 19h5l-11 -13v6z" }]
]);

export { IconBrandValorant as default };
//# sourceMappingURL=IconBrandValorant.js.map
